export const makeStorage = (props: Record<string, string> = {}) => {
  const storage: Record<string, string> = {
    ...props,
  };

  const s: Partial<Storage> = {
    ...storage,
    length: Object.keys(storage).length,
  };

  s.getItem = (key: string) => storage[key] || null;
  s.setItem = (key: string, value: string) => {
    s[key] = value;
    storage[key] = value;
  };
  s.removeItem = (key: string) => {
    delete storage[key];
    delete s[key];
  };
  s.clear = () => {
    Object.keys(storage).forEach(key => {
      delete storage[key];
      delete s[key];
    });
  };
  s.key = (index: number) => Object.keys(storage)[index];

  return s as Storage;
};
export const makeStorageProxy = (s: Storage) => ({
  ...s,
  getItem: (key: string) => s.getItem(key),
  setItem: (key: string, value: string) => s.setItem(key, value),
  removeItem: (key: string) => s.removeItem(key),
  clear: () => s.clear(),
  key: (index: number) => s.key(index),
  length: s.length,
});
